/* 曹真（字子丹） */
import { gd, along, spMul } from '../../core/kit.ts';
import type { Unit } from '../types.ts';
import { defineHero, hook, D } from '../define.ts';

export default defineHero({
  id: 'caozhen', name: '曹真', sub: '字子丹', faction: 'wei', role: '戰士', weapon: 'spear',
  look: { beard: 'goatee', bulk: 1.08, fx: '#9fc2ff', c: { cape: '#1e2a52', plume: '#c9a24e' } },
  skills: [
    ['督軍', 'charge', '督軍衝鋒，造成 {80/125/170/215} 傷害並擊飛 0.8 秒。'],
    ['堅守', 'shield', '舉槍防守，得到吸收 {120/190/260/330} 傷害的護盾 3 秒（身旁一名友將得到六成）。'],
    ['大將軍', 'passive', '600 內的友方武將（含自己）受到的控制時間 -{5/8/11/14}%。', { pv: {}, sig: 'general', ten: [5, 8, 11, 14] }],
    ['虎豹騎', 'charge', '虎豹騎虛影朝游標方向連續衝陣 3 次（每 0.5 秒一波，長 900），每次 {120/180/240} 傷害並擊飛 0.5 秒。', { x: { k: 'tiger3', dmg: [120, 180, 240], n: 3, len: 900, w: 160 }, aim: D(900, 80), cd: [100, 85, 70], mp: [150, 175, 200], el: 'earth', shout: '虎豹騎，衝陣！' }],
  ],
  // 專屬技能（技能資料裡的 x.k）
  kinds: {
    // 曹真「虎豹騎」：三波騎兵虛影衝陣
    tiger3(u, a, X) {
      const dir = a.dir, sp = spMul(u), from = along(u.x, u.y, dir, -100);
      for (let j = 0; j < X.n; j++) this.later(0.5 * j, () => {
        if (!u.alive) return;
        const hit: Record<number, number> = {};
        const p = this.shootProj(u, { dir, speed: 1000, range: X.len, rad: X.w / 2, shape: 'cavalry', el: 'earth', filter: (t: Unit) => !t.structure,
          onHit: (t: Unit) => { if (hit[t.id]) return false; hit[t.id] = 1; this.damage(u, t, X.dmg * sp, { magic: true, spell: true, stagger: 0.3 }); this.applyCC(u, t, { knockup: 0.5 }); return false; } });
        p.x = from[0]; p.y = from[1];
      });
    },
  },
  // 被動與專屬效果：hook(時間點, 順位, 處理)（時間點一覽見 core/hooks.ts）
  hooks: [
    // 大將軍：600 內的友將硬控制時間縮短（取最高）
    hook('cc.tenacity', 30, function (t, cc) {
      let gen = 0; for (const h of this.units) { const g = h.kind === 'hero' && h.alive && h.team === t.team && h.sg && h.sg.general; if (g && gd(h.x, h.y, t.x, t.y) <= 600) gen = Math.max(gen, g.v('ten')); }
      return gen;
    }),
  ],
  // 電腦什麼時候放這招
  ai: {
    tiger3: ({ w, u, t, d, hero, hpR, foeHeroes }) => hero && d < 750,
  },
});
